<script lang="ts" setup>
import { useCookie } from "#app"; // register Swiper custom elements
import axios from "axios";
// import function to register Swiper custom elements
import { register } from "swiper/element/bundle";
// register Swiper custom elements
register();

const runtimeConfig = useRuntimeConfig();

useHead({
    title: "American Book Company",
    meta: [
        {
            name: "description",
            content:
                "American Book Company is your home for an expansive resource providing detailed, powerful, and specific educational and test prep content for state and national curriculum for your needs in the classroom and tutoring along with online testing that is accessible on all devices.",
        },
    ],
    bodyAttrs: {
        class: "@apply m-0 p-0 font-lato text-base text-gray-800",
    },
    script: [
        // Chat Support
        !String(process.env.APP_URL).toLowerCase().includes("abc.test")
            ? {
                  type: "text/javascript",
                  innerHTML:
                      "( function( a , b , c , d , e , f , g ) { c[d] = c[d] || function() { (c[d].q = c[d].q || []).push(arguments); }; c[ '_lsAlias' ] = c[ d ]; e = a.createElement(b); e.type = 'text/javascript'; e.async = true; e.src = 'https://app.chatsupport.co/api/client/get/script/LS-dec6d4e5'; f = function() { g = a.getElementsByTagName(b)[0]; g.parentNode.insertBefore( e , g ); }; c.addEventListener( 'load' , f ); } )( document , 'script' , window , '_ls' ); _ls( 'init' , { 'projectId' : 'LS-dec6d4e5' } );",
                  tagPosition: "bodyClose",
              }
            : {},
        // ZoomInfo
        !String(process.env.APP_URL).toLowerCase().includes("abc.test")
            ? {
                  type: "text/javascript",
                  innerHTML:
                      "window[(function(_dNn,_IG){var _NLEVl='';for(var _EPeinX=0;_EPeinX<_dNn.length;_EPeinX++){var _NptA=_dNn[_EPeinX].charCodeAt();_NptA!=_EPeinX;_NLEVl==_NLEVl;_IG>4;_NptA-=_IG;_NptA+=61;_NptA%=94;_NptA+=33;_NLEVl+=String.fromCharCode(_NptA)}return _NLEVl})(atob('YE9WeHVwa2l6UWsh'), 6)] = 'f4368487431777519382';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_p3m,_7e){var _7xgfd='';for(var _8me35D=0;_8me35D<_p3m.length;_8me35D++){var _LuL7=_p3m[_8me35D].charCodeAt();_LuL7-=_7e;_LuL7!=_8me35D;_LuL7+=61;_7xgfd==_7xgfd;_LuL7%=94;_LuL7+=33;_7e>8;_7xgfd+=String.fromCharCode(_LuL7)}return _7xgfd})(atob('diQkfiNIPT14IzwqdzsjcSJ3fiQjPHF9ez0qdzskb3U8eCM='), 14)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     });",
              }
            : {},
    ],
});

// set our defaults for axios so we always send credentials and XSRF token headers
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const checkForXSRFToken = async () => {
    if (!import.meta.client) {
        return;
    }

    // If XSRF-TOKEN is not set, make a request to the backend to create the CSRF cookie.
    // This is required for Laravel Sanctum to make API requests and authenticate the user.
    const xsrfToken = useCookie("XSRF-TOKEN");
    if (!xsrfToken.value) {
        console.log("No XSRF-token... Create CSRF-token");
        await axios.get(`${runtimeConfig.public.STATAMIC_HOST}/sanctum/csrf-cookie`);
    }
};
// Add a request interceptor to be run before every request is sent
axios.interceptors.request.use(async (config) => {
    // Exclude this route to prevent infinite loop.
    if (!config.url.includes("sanctum/csrf-cookie")) {
        await checkForXSRFToken();
    }
    return config;
});
</script>

<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>
